/**
 * Utility functions for persisting view state across navigation
 */
import React from 'react';

const VIEW_STATE_KEY_PREFIX = 'bondcollective_view_';

export const saveViewState = (componentName, viewState) => {
  try {
    const key = `${VIEW_STATE_KEY_PREFIX}${componentName}`;
    localStorage.setItem(key, JSON.stringify(viewState));
  } catch (error) {
    console.warn('Failed to save view state:', error);
  }
};

export const loadViewState = (componentName, defaultState = {}) => {
  try {
    const key = `${VIEW_STATE_KEY_PREFIX}${componentName}`;
    const saved = localStorage.getItem(key);
    
    if (saved) {
      return { ...defaultState, ...JSON.parse(saved) };
    }
  } catch (error) {
    console.warn('Failed to load view state:', error);
  }
  
  return defaultState;
};

export const clearViewState = (componentName) => {
  try {
    const key = `${VIEW_STATE_KEY_PREFIX}${componentName}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.warn('Failed to clear view state:', error);
  }
};

// Hook for easy view state management
export const useViewState = (componentName, defaultState = {}) => {
  const [viewState, setViewStateInternal] = React.useState(() => 
    loadViewState(componentName, defaultState)
  );

  const setViewState = React.useCallback((newState) => {
    const updatedState = typeof newState === 'function' 
      ? newState(viewState) 
      : { ...viewState, ...newState };
    
    setViewStateInternal(updatedState);
    saveViewState(componentName, updatedState);
  }, [componentName, viewState]);

  return [viewState, setViewState];
};